import { render, staticRenderFns } from "./UserStatsWidget.vue?vue&type=template&id=2b09ba80&scoped=true&"
import script from "./UserStatsWidget.vue?vue&type=script&lang=js&"
export * from "./UserStatsWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserStatsWidget.vue?vue&type=style&index=0&id=2b09ba80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09ba80",
  null
  
)

export default component.exports